export const A_EQUALS_B = 0
export const A_AFTER_B = 1
export const A_BEFORE_B = -1
